import type { ReactNode } from 'react';
import { Flex } from '@mantine/core';
import { zodResolver } from 'mantine-form-zod-resolver';

import { EditVacancyTariff } from '../editVacancyTariff';
import {
  type VacancyEditMainInfoInitialValues,
  VacancyEditMainInfoSchema,
} from './types';

import { createFormContext } from '@mantine/form';

export const [
  VacancyEditMainInfoFormProvider,
  useVacancyEditMainInfoFormContext,
  useVacancyEditMainInfoForm,
] = createFormContext<VacancyEditMainInfoInitialValues>();

type VacancyEditMainInfoFormRootProps = {
  initialValues: VacancyEditMainInfoInitialValues;
  children: ReactNode;
};

/** Оборачивает разметку страницы вакансии в режиме редактирования: форма доступна через контекст. */
export const VacancyEditMainInfoFormRoot = ({
  initialValues,
  children,
}: VacancyEditMainInfoFormRootProps) => {
  const form = useVacancyEditMainInfoForm({
    initialValues,
    validate: zodResolver(VacancyEditMainInfoSchema),
  });

  return (
    <VacancyEditMainInfoFormProvider form={form}>
      {children}
    </VacancyEditMainInfoFormProvider>
  );
};

/** Поле тарифа вне основной колонки формы — привязка к той же форме через [Form context](https://v8.mantine.dev/form/create-form-context/). */
export const VacancyEditMainInfoTariffField = () => {
  const form = useVacancyEditMainInfoFormContext();

  return (
    <Flex maw={418} w='100%'>
      <EditVacancyTariff {...form.getInputProps('tariffId')} />
    </Flex>
  );
};
